import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import ServerContextService from '@/core/server-context.service';
import { parse, format, isValid } from 'date-fns';
import DatePicker from 'vue2-datepicker';
import datePickerLocale from '@/core/datepickerlocales.service';
import DatePickerService from '@/services/datepicker.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'DateRangePicker',
  props: {
    value: null,
    startLabel: null,
    endLabel: null,
    minDate: null,
    maxDate: null,
    startTabindex: null,
    endTabindex: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', value: any): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value?: any,
    startLabel?: string,
    endLabel?: string,
    minDate?: Date,
    maxDate?: Date,
    startTabindex?: string,
    endTabindex?: string
}

const start = ref(null);
const end = ref(null);





const hover = ref<boolean>(false);
const activateHover = ref<boolean>(false);

// Used for resetting all values when picking first date (emulate vCalendar behaviour)
let pickCount = 0;

const locale: object = datePickerLocale[ServerContextService.twoLetterISOLanguageName];

const range = computed<any>({
    get() {
        return [
            props.value.start,
            props.value.end
        ];
    },
    set(value: any) {
        emit('input', value);
    }
});

const rangeStart = computed<string>({
    get() {
        if (range.value[0] === null) {
            return format(new Date(), ServerContextService.dateFormat);
        }
        return format(range.value[0], ServerContextService.dateFormat);
    },
    set(value: string) {
        if (DatePickerService.validateDateStringLength(value)) {
            return;
        }
        const start = parse(DatePickerService.stripSpecialCharacters(value), DatePickerService.stripSpecialCharacters(ServerContextService.dateFormat), new Date());

        if (DatePickerService.validateDateYear(start)) {
            return;
        }
        if (isValid(start)) {
            range.value = [
                start,
                range.value[1]
            ];
        }
    }
});

const rangeEnd = computed<string>({
    get() {
        if (range.value[1] === null) {
            return format(new Date(), ServerContextService.dateFormat);
        }
        return format(range.value[1], ServerContextService.dateFormat);
    },
    set(value: string) {
        if (DatePickerService.validateDateStringLength(value)) {
            return;
        }
        const end = parse(DatePickerService.stripSpecialCharacters(value), DatePickerService.stripSpecialCharacters(ServerContextService.dateFormat), new Date());

        if (DatePickerService.validateDateYear(end)) {
            return;
        }
        if (isValid(end)) {
            range.value = [
                range.value[0],
                end
            ];
        }
    }
});

const dateFormat = computed<string>(() => {
    return ServerContextService.dateFormat.toUpperCase();
});

function disabledDate(date): boolean {
    return date < props.minDate || date > props.maxDate;
}

function formatDate(date: Date): string {
    return format(date, ServerContextService.dateFormat);
}

function onFocus(): void {
    activateHover.value = true;
}

function onBlur(): void {

}

function onMouseover(): void {
    hover.value = true;
}

function onMouseleave(): void {
    hover.value = false;
    activateHover.value = false;
    (start.value.$refs.input as HTMLInputElement).blur();
    (end.value.$refs.input as HTMLInputElement).blur();
}

function onDatePickerInput(date): void {
    (start.value.$refs.input as HTMLInputElement).value = formatDate(date[0]);
    (end.value.$refs.input as HTMLInputElement).value = formatDate(date[1]);
}

function onDatePickerPick(date): void {
    pickCount++;
    if (pickCount === 2) {
        pickCount = 0;
        return;
    }
    const formattedDate = formatDate(date);
    (start.value.$refs.input as HTMLInputElement).value = formattedDate;
    (end.value.$refs.input as HTMLInputElement).value = formattedDate;
}

return { __sfc: true,start, end, props, emit, hover, activateHover, pickCount, locale, range, rangeStart, rangeEnd, dateFormat, disabledDate, formatDate, onFocus, onBlur, onMouseover, onMouseleave, onDatePickerInput, onDatePickerPick, DatePicker }
}

})